import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import Swal from "sweetalert2";
import "./stage4.css";

import instaImg from "./images/insta.jpg";
import submitImg from "./images/submit.png";
import successGif from "./images/success.gif";

import { fetchReport, updateReport } from "../../scoreservice";
// import { useStageTimer } from "../../hooks/useStageTimer";

Modal.setAppElement("#root");

const STAGE = 4;
const timeToSeconds = (timeStr = "00:00") => {
  const [m = 0, s = 0] = timeStr.split(":").map(Number);
  return m * 60 + s;
};

const Stage4 = ({ updateHeader }) => {
  useEffect(() => {
    updateHeader({ backButtonRedirect: "/stage4" });


  }, []); // run once on mount
  const navigate = useNavigate();

  // const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const [userData, setUserData] = useState({});

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("userData");
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);


  const [points, setPoints] = useState(0);
  const [totalScore, setTotalScore] = useState(0);
  const [answer, setAnswer] = useState("");
  const [correctSelected, setCorrectSelected] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [initialTime, setInitialTime] = useState("00:00");
  const [ready, setReady] = useState(false);

  const [SESSION_KEY, setSessionKey] = useState(null);
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);

  /* ⏱ TIMER */
  // const { seconds, stopTimer } = useStageTimer(
  //   STAGE,
  //   ready ? initialTime : null
  // );

  // const formatTime = (secs) => {
  //   const m = String(Math.floor(secs / 60)).padStart(2, "0");
  //   const s = String(secs % 60).padStart(2, "0");
  //   return `${m}:${s}`;
  // };
  const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  const isCorrect = answer.trim().toLowerCase() === "warehouse";
  useEffect(() => {
    const checkStageCompletion = async () => {
      try {
        const res = await fetchReport({
          userId: userData.userId,
          sessionId: userData.sessionId,
          organizationId: userData.organizationId,
          stage: STAGE,

        });

        if (userData?.sessionId && userData?.userId) {
          const key = `stage_timer_${userData.sessionId}_${userData.userId}`;
          setSessionKey(key);

          if (!sessionStorage.getItem(key)) {
            sessionStorage.setItem(
              key,
              JSON.stringify({
                userId: userData.userId,
                sessionId: userData.sessionId,
                startTime: Date.now(),
              })
            );
          }
        }


        console.log("data4", res);
        if (Number(res?.points) !== 0) {
          navigate("/stage5", { replace: true });
        }


      } catch (err) {
        console.error("Stage check failed", err);
      }
    };

    if (userData?.sessionId) {
      checkStageCompletion();
    }
  }, [userData]);


  useEffect(() => {
    const loadStageData = async () => {
      if (!userData?.userId) return;

      try {
        const res = await fetchReport({
          userId: userData.userId,
          sessionId: userData.sessionId,
          organizationId: userData.organizationId,
          stage: STAGE,
        });

        if (res.status === "success") {
          setPoints(res.points || 0);
          setTotalScore(res.total_score || 0);
          setInitialTime(res.time || "00:00");

          if ((res.points || 0) > 0) {
            setCorrectSelected(true);
          }
        }
      } catch (err) {
        console.error("Stage4 fetch failed", err);
      } finally {
        setReady(true);
      }
    };

    loadStageData();
  }, [userData]);

  /* 🔹 SUBMIT */
  const handleSubmit = async () => {
    console.log("handle submit");
    if (!isCorrect || correctSelected) return;

    // stopTimer();
    setPoints(1);
    setCorrectSelected(true);
    console.log("total score444---", totalScore);
    try {
      await updateReport({
        sessionId: userData.sessionId,
        userId: userData.userId,
        organizationId: userData.organizationId,
        reportId: userData.reportId,
        stage: STAGE,
        score: Number(totalScore) + 1,
        // time: formatTime(seconds),
        time: formattedTime,
        roles: userData.roles,
        token: userData.token || ""

      });

      Swal.fire({
        imageUrl: "/img/success.gif",
        showConfirmButton: false,
        timer: 3000,
        background: "transparent",
      });

      setTimeout(() => {
        navigate("/stage5");
      }, 3000);
    } catch (err) {
      console.error("Stage4 submit error", err);
    }
  };


  // useEffect(() => {
  //   const sessionData = sessionStorage.getItem(SESSION_KEY);

  //   if (!sessionData) return;

  //   const { startTime } = JSON.parse(sessionData);

  //   const interval = setInterval(() => {
  //     const elapsedMs = Date.now() - startTime;
  //     const totalSeconds = Math.floor(elapsedMs / 1000);

  //     const mins = Math.floor(totalSeconds / 60);
  //     const secs = totalSeconds % 60;

  //     setMinutes(mins);
  //     setSeconds(secs);
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [SESSION_KEY])



  useEffect(() => {
    if (!initialTime) return;

    const baseSeconds = timeToSeconds(initialTime);
    const startTime = Date.now();

    const interval = setInterval(() => {
      const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
      const totalSeconds = baseSeconds + elapsedSeconds;

      setMinutes(Math.floor(totalSeconds / 60));
      setSeconds(totalSeconds % 60);
    }, 1000);

    return () => clearInterval(interval);
  }, [initialTime]);


  return (
    <div className="stage4-page-bg">
      <div className="stage4-page">

        {/* HEADER
        <div className="top-bar">
          <div className="timer-back-4">
            Time : {ready ? formatTime(seconds) : "00:00"}
          </div>
          <div className="score-4">Points : {totalScore}</div>

            <h4 className="gameHead-4">
          Forensic Checks: Identify the key suspect
        </h4>
        </div> */}


        <div className="row header4">
          <div className="timer-4">
            Time: {formattedTime}
          </div>

          <h4 className="gameHead-4">
            Digital Footprints: Track suspects using their social media activity

          </h4>

          <div className="score-4">Points: {totalScore}</div>
        </div>


        {/* IMAGE */}
        <div className="main-4 insta-img" onClick={() => setShowModal(true)}>
          {/* <img
            src={instaImg}
            className="insta-img"
            onClick={() => setShowModal(true)}
            alt="insta"
          /> */}
        </div>

        {/* MODAL */}
        <Modal
          isOpen={showModal}
          onRequestClose={() => setShowModal(false)}
          className="stage4-modal"
          overlayClassName="stage4-overlay"
        >
          <span className="close" onClick={() => setShowModal(false)}>
            &times;
          </span>

          <div className="modal-img-wrapper">
            <h4 className="modal-title4">
              Identify the key location and enter it in the text box.
            </h4>

            <img src={instaImg} alt="modal" style={{ width: "100%" }} />
            <input
              type="text"
              className="input-box"
              placeholder="Enter your answer"
              value={answer}
              onChange={(e) => {
                if (!isCorrect) {
                  setAnswer(e.target.value);
                }
              }}
              disabled={isCorrect}
              style={{
                backgroundColor:
                  answer.length === 0
                    ? "#fff"
                    : isCorrect
                      ? "#1bc01b"
                      : "#f12c2c",
                color: answer.length === 0 ? "#000" : "#fff",
              }}
            />

          </div>

          <div className="text-center">
            <img
              src={submitImg}
              className="submit_btn"
              alt="submit"
              onClick={handleSubmit}
              style={{
                opacity: isCorrect ? 1 : 0.5,
                pointerEvents: isCorrect ? "auto" : "none",
              }}
            />
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default Stage4;
